import React, { Component } from 'react';
import { PropTypes as MobxPropTypes, inject, observer } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import { Form, Input, Select } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim } from '../../GeneralStyle'
import InvoiceTable from '../../Tables/InvoiceTable';
import config from 'react-global-configuration';
import Parse from 'parse'
import PreviewContractModal from "../../internal/Modals/PreviewContractModal"

@inject("adminStore")

@observer
class ContractForm extends Component {
		constructor(props) {
				super(props)
				this.state = {
						contract: {...this.props.contract, year: (new Date()).getFullYear()},
						isLoading: false,
						isManualLoading: false,
						editYear: this.props.contract.year === -1,
				}
		}

		componentDidUpdate(prevProps) {
			if (prevProps.contract !== this.props.contract)
				this.setState({ contract: {...this.props.contract, year: (new Date()).getFullYear()}, editYear: this.props.contract.year === -1 })
		}

		send = async () => {
			try {
				this.setState({isLoading: true})

				const query = new Parse.Query("Contract");
				const contract = await query.get(this.state.contract.objectId)
				// contract.set("title", this.state.contract.title)
				contract.set("fee", Number(this.state.contract.fee))
				if(this.state.editYear) contract.set("year", Number(this.state.contract.year))

				await contract.save()
				await Parse.Cloud.run("sendContractMail", { contractId: this.state.contract.objectId })

				contract.set("isPending", false)
				await contract.save()

				this.props.history.push(`/`)
				this.props.history.push(`/internal/admin/contracts/${this.state.contract.objectId}`)

			} catch (e) {
				console.error(e);
				this.setState({isLoading: false})
			}
		}

		manual = async () => {
			try {
				this.setState({isManualLoading: true})

				const query = new Parse.Query("Contract");
				const contract = await query.get(this.state.contract.objectId)

				contract.set("isManual", true)
				contract.set("isSent", true)
				contract.set("isPending", false)

				contract.set("fee", Number(this.state.contract.fee))
				if(this.state.editYear) contract.set("year", Number(this.state.contract.year))

				await contract.save()

				this.props.history.push(`/`)
				this.props.history.push(`/internal/admin/contracts/${this.state.contract.objectId}`)

			} catch (e) {
				console.error(e);
				this.setState({isManualLoading: false})
			}
		}

		render() {

				const contract = this.state.contract
				const invoices = this.props.invoices

				const date = new Date()
				const year = date.getFullYear()

				const dateOptions = [
					{
						value: year,
						label: year,
					},
					{
						value: year+1,
						label: year+1,
					}
				]

				if(!(contract && contract.company))
					return (
						<ContainerBox>
						<Row style={{ padding: 25, margin: 'auto' }}>
						<Col md={12} style={{textAlign: "center", color: "black"}}>
							Vertrag konnte nicht geladen werden
						</Col>
						</Row>
						</ContainerBox>
					)

				return (
						<div style={{maxWidth: 1200, margin: "0 auto"}}>
						<ContainerBox>
								<Row style={{ padding: 25, margin: 'auto' }}>
									<Heading style={{paddingLeft: 0, marginLeft: 37, display: "inline-block"}}>
										{ this.state.editYear ? "Vertragseinstellungen setzen:" : "Manuelle Vertragsfreigabe:"}
									</Heading>

									<div style={{ paddingLeft: 0, marginLeft: 37, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>

										<Form
												className={'dashboard-form'}
												layout={'vertical'}
												validateOnSubmit={false}
												validatePristine={false}
												formNoValidate
												noValidate
										>

											<Col md={5}>
											{ this.state.editYear ?
												<Select
														name="contract_year"
														label="Vertragsjahr"
														options={dateOptions}
														required
														onChange={(name, value) => this.setState({ contract: { ...contract, year: Number(value) } })}
												/>
												:
												<Input
													name="year"
													label="Jahr"
													value={ contract.year }
													type="text"
													disabled
												/>
											}
											</Col>

											<Col md={5}>
												<Input
													name="company"
													label="Firma"
													value={ contract.company.shortname }
													type="text"
													disabled
												/>
											</Col>

											<Col md={2} style={{ paddingTop: 35, paddingRight: 35 }}>
												<LogeButtonSlim
								          hoverFontColor={"white"}
													style={{width: "100%"}}
								          onClick={() => { this.props.history.push(`/internal/admin/companies/${contract.company.objectId}`) }}>
								            Firma anzeigen
								        </LogeButtonSlim>
											</Col>

											<Col md={5}>
											<Input
												name="fee"
												label="Jahres Betrag"
												value={ contract.fee }
												addonAfter="€"
												type="text"
												onChange={(name, value) => this.setState({ contract: { ...contract, fee: Number(value) } }) }
											/>
											</Col>

											<Col md={12} style={{display: "block"}}>
											</Col>


											<Col md={1}></Col>

											<Col md={3} /*style={{ paddingTop: 35}}*/>
												<LogeButtonSlim
								          hoverFontColor={"white"}
													style={{width: "100%"}}
								          onClick={() => { this.preview.open() } }>
								            Vorschau anzeigen
								        </LogeButtonSlim>
											</Col>

											<Col md={4} /*style={{ paddingTop: 35}}*/>
												<LogeButtonSlim
								          hoverFontColor={"white"}
													style={{width: "100%"}}
													disabled={this.state.isLoading}
								          onClick={() => { this.send() }}>
								            { this.state.isLoading ? "Lade..." : "Vertrag senden"}
								        </LogeButtonSlim>
											</Col>
											<Col md={3} /*style={{ paddingTop: 35}}*/>
												<LogeButtonSlim
								          hoverFontColor={"white"}
													style={{width: "100%"}}
													disabled={this.state.isManualLoading}
								          onClick={this.manual}>
								            { this.state.isManualLoading ? "Lade..." : "Manuell gesendet"}
								        </LogeButtonSlim>
											</Col>

											<Col md={1}></Col>

											<Col md={12} style={{ paddingTop: 35, textAlign: "center", }}>
												<LogeButtonSlim
								          hoverFontColor={"white"}
								          onClick={() => { this.props.history.push(`/internal/admin/contracts/`) }}>
								            zurück zur Liste
								        </LogeButtonSlim>
											</Col>
										</Form>
								</Row>
							</ContainerBox>
							<PreviewContractModal ref={instance => { this.preview = instance; }} contract={contract}/>
					</div>
				);
		}
}

ContractForm.propTypes = {
		userStore: MobxPropTypes.observableObject,
		cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(ContractForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/PendingContractForm.js